import { useQuery } from "@apollo/client"
import { GetDraft } from "routes/schedule/get-draft"
import { AdaptSchedule } from "event-definitions"
import { clone } from "lib/clone"

export function useDraft(id) {
    const { data: { schedule } = {}, loading, error } = useQuery(GetDraft, { variables: { id } })
    return AdaptSchedule.call({ loading, error, schedule: clone(schedule) ?? null })
}
